
import type { AgentClientDefinition, AgentClientPluginsDefinition } from "@/agent/client/types";
import { PluginClientAtomDefinition, PluginClientAtomsDefinition, PluginClientConfig, PluginClientDefinition, PluginClientExtensionDefinition } from "@/plugins/client/types";
import { PluginConfig, PluginDefinition } from "@/plugins/server/types";
import * as op from "@/shared/operation";

export type ClientBuildType = Record<
  string,
  {
    definition: AgentClientDefinition;
    plugins: Record<
      string,
      {
        def: PluginClientDefinition;
        $types: {
          atoms: ReturnType<PluginClientAtomsDefinition>;
          class: ReturnType<PluginClientExtensionDefinition>;
          serverConfig: PluginConfig<PluginDefinition["config"], "output">;
          clientConfig: PluginClientConfig<PluginClientDefinition["config"], "output">;
        };
      }
    >;
  }
>;

// Those uppercased placeholders will be replaced during compilation.
type Mode = "LIFE_BUILD_MODE";
const module: string | Promise<{ default: ClientBuild }> = String("LIFE_CLIENT_BUILD_MODULE");

// @ts-expect-error
type ActualClientBuild = typeof import("LIFE_CLIENT_BUILD_PATH");

const defaultBuild = { 
  "Run `life dev` to see your agents here.": {} as ClientBuildType[string] 
} as const satisfies ClientBuildType;



export type ClientBuild = Mode extends "production" 
  ? Awaited<ActualClientBuild>["default"] extends never 
  ? Awaited<ActualClientBuild>
  : Awaited<ActualClientBuild>["default"] : typeof defaultBuild

/* @__PURE__ */
export async function importClientBuild(): Promise<op.OperationResult<ClientBuild>> {  
  if (typeof module === "string") return op.success(defaultBuild as ClientBuild); 
  else return op.success((await module).default as ClientBuild);
}

